import type { IIssuerByTickerSymbolQuery } from "lib/queries/__generated__/IssuerByTickerSymbolQuery.generated";

export default function getMatchedSecurity(
  issuer: NonNullable<IIssuerByTickerSymbolQuery["issuerByTickerSymbol"]>,
  tickerSymbol: string,
) {
  if (issuer.__typename === "BrazilianCompanyIssuer") {
    const matchedSecurity = issuer.securities.find((candidate) => {
      return candidate.tickerSymbol === tickerSymbol;
    });
    if (matchedSecurity) {
      return matchedSecurity;
    }
    const topSecurities = [...issuer.securities].sort((a, b) => {
      return b.sharesOutstanding - a.sharesOutstanding;
    });
    if (topSecurities.length > 0) {
      return topSecurities[0];
    }
    return null;
  }

  if (issuer.__typename === "AmericanCompanyIssuer") {
    const matchedSecurity = issuer.securities.find((candidate) => {
      return candidate.tickerSymbol === tickerSymbol;
    });
    if (matchedSecurity) {
      return matchedSecurity;
    }

    return null;
  }

  return null;
}
